/**
 * /convite/:token — container. O visual é o painel do design novo
 * (entrada/PainelConvite), dentro da mesma moldura do login
 * (entrada/TelaDeEntrada, rota de layout em App.jsx).
 *
 * Fluxo:
 *   1. GET /api/convite/<token> valida o link e traz nome, e-mail, cargo e
 *      empresa (a tela é anterior ao login: o nome da empresa vem daqui,
 *      nunca fixo no front).
 *   2. A pessoa cria a senha; POST /api/convite/<token>/aceitar consome o
 *      convite.
 *   3. "Ir para o login" leva o e-mail já preenchido.
 *
 * Sem token JWT em nenhuma chamada: quem abre o convite ainda não tem
 * sessão.
 */
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import PainelConvite, {
  ESTADO_CARREGANDO,
  ESTADO_CONCLUIDO,
  ESTADO_FORMULARIO,
  ESTADO_INVALIDO,
} from "../Auth/entrada/PainelConvite";
import { ACCESS_API_URL } from "../../config/api";

async function chamarPublico(path, options = {}) {
  const headers = new Headers(options.headers || {});
  if (options.body && !headers.has("Content-Type")) {
    headers.set("Content-Type", "application/json");
  }
  const resp = await fetch(`${ACCESS_API_URL}${path}`, {
    ...options,
    headers,
    cache: "no-store",
  });
  const text = await resp.text();
  let payload = null;
  if (text) {
    try {
      payload = JSON.parse(text);
    } catch {
      payload = { erro: text };
    }
  }
  if (!resp.ok) {
    const erro = new Error(payload?.erro || payload?.detalhe || `Falha (${resp.status})`);
    erro.status = resp.status;
    throw erro;
  }
  return payload;
}

export default function ConviteUsuario() {
  const { token } = useParams();
  const navigate = useNavigate();
  const [estado, setEstado] = useState(ESTADO_CARREGANDO);
  const [convite, setConvite] = useState(null);
  const [mensagemDeErro, setMensagemDeErro] = useState("");

  useEffect(() => {
    let ativo = true;
    chamarPublico(`/api/convite/${encodeURIComponent(token)}`)
      .then((resp) => {
        if (!ativo) return;
        setConvite(resp?.data || resp);
        setEstado(ESTADO_FORMULARIO);
      })
      .catch((err) => {
        if (!ativo) return;
        setMensagemDeErro(err?.message || "");
        setEstado(ESTADO_INVALIDO);
      });
    return () => {
      ativo = false;
    };
  }, [token]);

  async function definirSenha({ nova, confirmacao }) {
    await chamarPublico(`/api/convite/${encodeURIComponent(token)}/aceitar`, {
      method: "POST",
      body: JSON.stringify({ nova_senha: nova, confirmar_nova_senha: confirmacao }),
    });
    setEstado(ESTADO_CONCLUIDO);
  }

  function irParaLogin() {
    navigate("/login", { replace: true, state: { email: convite?.usuario?.email || "" } });
  }

  return (
    <PainelConvite
      estado={estado}
      convite={convite}
      mensagemDeErro={mensagemDeErro}
      definirSenha={definirSenha}
      onIrParaLogin={irParaLogin}
    />
  );
}
